
import { Component, Vue } from "vue-property-decorator";
import ButtonAction from "@/components/buttons/Button.vue";
import { toast } from "@/store";
import { TYPE } from "@/store/modules/toast.module";
import LoginService from "@/services/login.service";
import { LocalStorageApp } from "@/utils/localstorage";
import { isPasswordStrong } from "@/helpers";

/** Login screen — username/password form. Redirects to the "unlock" screen if a token already exists (unless `?change_compte` is set). */
@Component({
  components: { ButtonAction },
})
export default class Login extends Vue {
  private username = "";
  private userpasswd = "";

  private backgroundImage = {
    backgroundImage: `url(${require("@/assets/images/photos/IMG_5378.jpg")})`,
  };

  async mounted(): Promise<void> {
    const token: string = LocalStorageApp.getItem("pcp.token") ?? "";
    if (token && !this.$route.query.change_compte) {
      this.$router.push({ path: "/deverrouiller", query: this.$route.query });
    }
  }

  /** Submits the login form; clears the password on failure. */
  private async login() {
    if (this.username && this.userpasswd) {
      if (await LoginService.login(this.username, this.userpasswd)) {
        const passwordWeak = !isPasswordStrong(this.userpasswd);
        LocalStorageApp.setItem("pcp.mustChangePassword", passwordWeak);
        const go = this.$route.query.go as string | undefined;
        if (passwordWeak) {
          this.$router.replace(
            go
              ? `/securiser-mot-de-passe?go=${encodeURIComponent(go)}`
              : "/securiser-mot-de-passe"
          );
        } else {
          this.$router.replace(go || "/");
        }
      } else {
        this.userpasswd = "";
      }
    } else {
      toast.createAndPushToast(
        "Veuillez saisir un nom d'utilisateur et un mot de passe",
        "",
        true,
        TYPE.INFO
      );
    }
  }
}
